import React, { FunctionComponent } from 'react'
import { Layout } from '@vwfs-bronson/bronson-react'
import { Output } from '../../../Text'

export type TextsRenderProps = {
  texts: string[],
  templateValues?: any,
}

const TextsRender: FunctionComponent<TextsRenderProps> = props => {
  const { texts, templateValues } = props;

  return (
    texts?.length > 0
      ? (
        <Layout>
          {texts?.map((text:string) => (
            <Layout.Item default="1/1">
              {
                <span key={text}>
                  {Output.markdown(Output.templateWithValues(
                    text,
                    templateValues
                  ))}
                </span>
              }
            </Layout.Item>
          ))}
        </Layout>
      )
      : <></>
  );
}

export default TextsRender;
